export const mediaDrillDownNames = ['EVFLAG_AVA', 'EVFLAG_PVM', 'EVFLAG_IVM', 'EVFLAG_RVA', 'EVFLAG_RPM', 'EVFLAG_GVM'];
